import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colour from 'color';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #D7DFE7;
  box-sizing: border-box;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  margin-right: 24px;
  background-color: ${props => props.bgColor};
  margin-top: -16px;
  width: 118px;
  height: 118px;

  ${props => props.theme.isLarge && `
    width: 152px;
    height: 152px;
  `};
  ${props => props.theme.isXLarge && `
    margin-top: -24px;
  `};
`;

const ImageContainer = styled.div`
  width: 93px;
  margin: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.theme.isLarge && `
    width: 117px;
  `};
`;

const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const white = Colour('white').hex();
export default function Logo({ url, color }) {
  let c;
  try {
    c = Colour(color || white);
  } catch (err) {
    c = Colour(white);
  }
  const bgColor = c.hex();
  return (
    <Container bgColor={bgColor}>
      {!!url && (
        <ImageContainer>
          <Img src={url} />
        </ImageContainer>
      )}
    </Container>

  );
}

Logo.propTypes = {
  url: PropTypes.string,
  color: PropTypes.string,
};

Logo.defaultProps = {
  url: null,
  color: null,
};
